import React, { useCallback, useEffect, useState } from "react";
import styles from "./CompletedTasks.module.css";
import {
  TextField,
  Button,
  FormGroup,
  Box,
  Skeleton,
  Drawer,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CompletedCard from "../CompletedCard/CompletedCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import FilterDrawer from "../../../../../components/FilterDrawer/FilterDrawer";
import { useSelector } from "react-redux";
import { useAuthUser } from "react-auth-kit";
import { useLocation, useNavigate } from "react-router-dom";
import ClearFilter from "../../../../../components/ClearFilter/ClearFilter";
import FilterTypeWrap from "../../../../../components/FilterDrawer/FilterTypeWrap";
import FilterLabel from "../../../../../components/FilterDrawer/FilterLabel/FilterLabel";
import FilterCheckBoxWrap from "../../../../../components/FilterDrawer/FilterCheckBoxWrap";
import FilterCheckbox from "../../../../../components/FilterDrawer/FilterCheckbox/FilterCheckbox";
import FilterChipsWrap from "../../../../../components/FilterDrawer/FilterChips/FilterChipsWrap";
import FilterChips from "../../../../../components/FilterDrawer/FilterChips/FilterChips";
import getAccessStatus, {
  getSubDomainAccessStatus,
} from "../../../../../components/RolePermissionAccess/RolePermissionAccess";
import { GetTaskBoard } from "../../service/tasks.request";
import InfiniteScroll from "react-infinite-scroll-component";
import UserAvatarGroup from "../../../../../components/UserAssign/UserAvatarGroup";
import { PuffLoader } from "react-spinners";
import {
  resetTaskBoard,
  getTaskById,
  resetTaskById,
  updateTaskStatus,
  resetTaskUpdateSuccess,
} from "../../service/tasksSlice";
import { useDispatch } from "react-redux";
import dayjs from "dayjs";
import TaskDetails from "../../../../../components/TaskCreation/TaskDetails";
import {
  CreateTask,
  EditTask,
  DeleteTask,
  CreateComment,
  DeleteComment,
  EditComment,
} from "../../../Nurture/service/nurture.request";
import {
  resetDeleteTaskSuccess,
  resetEditTaskSuccess,
} from "../../../Nurture/service/nurtureSlice";
import { setToastNotification } from "../../../../../components/ToastNotification/service/toastNotificationSlice";
import { clearTaskBoardRefresh } from "../../../../../service/websocketNotificationsSlice";
import { formatTaskCategory } from "../../../../../components/CommonFunctions/CommonFunctions";

type Data = {
  instituteId: string;
  startDate: any;
  endDate: any;
  limit: number;
  userId?: any;
  branchId?: any;
  lanesToFetch?: {
    status: string;
    lastEvaluatedKey: string;
    lastEvaluatedSortKey: string;
  }[];
};

function CompletedTasks(props: any) {
  const { GetTasksByDateForAssignee, GetTasksBoard } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const { userById } = useSelector((state: any) => state.userDetails);
  const {
    taskStatusUpdateSuccess,
    taskById,
    taskPriorityUpdateSuccess,
    taskAssigneeUpdateSuccess,
  } = useSelector((state: any) => state.tasks);
  const hasAllBranchAccess = getSubDomainAccessStatus(
    "GLOBAL_PERMISSIONS",
    "BRANCH_ACCESS",
    "ALL_BRANCHES",
    userById?.rolePermission,
  );
  const hasAllTaskAccess = getAccessStatus(
    "TASKS",
    "ALL_OTHER_USERS'_TASK",
    userById?.rolePermission,
  );

  const taskList = useSelector((state: any) => state.tasks.tasksboard);
  const {
    leadBoard,
    editTaskSuccess,
    deleteTaskSuccess,
    lastDeletedTaskCategory,
    lastEditedTaskCategory,
  } = useSelector((state: any) => state.nurture);

  const { lastCreatedTaskId } = useSelector((state: any) => state.nurture);
  const { taskUpdateNotify } = useSelector(
    (state: any) => state.websocketNotifications,
  );
  const tasksTypes = leadBoard?.taskType;

  const taskBoardloading = useSelector(
    (state: any) => state.tasks.taskBoardloading,
  );
  const employees = useSelector((state: any) => state.staff.staffList);
  const [taskItems, setTaskItems] = useState<any>();
  const [selectedTeamMember, setSelectedTeamMember] = React.useState<any>([]);
  const [hasMoreData, setHasMoreData] = useState<boolean>(true);
  const [highlightedTaskId, setHighlightedTaskId] = useState<string | null>(
    null,
  );

  const [leadSearchTerm, setLeadSearchTerm] = React.useState<any>("");

  const [selectedDate, setSelectedDate] = React.useState<number | null>(null);

  const [filterApplied, setFilterApplied] = React.useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = React.useState<boolean>(false);
  const [selectedGeneralTaskId, setSelectedGeneralTaskId] = useState<
    string | null
  >(null);
  const completedTasks =
    taskList && taskItems?.find((task: any) => task.stateName === "COMPLETED");

  function handleGoBack() {
    dispatch(resetTaskBoard());
    if (location?.state?.taskSelectedId) {
      navigate(`/app/Tasks?selectedUsers=${location?.state?.taskSelectedId}`);
    } else {
      navigate(`/app/Tasks`);
    }
  }

  const handleLeadSearch = (event: any) => {
    setLeadSearchTerm(event.target.value);

    const urlSearchParams = new URLSearchParams(window.location.search);

    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskDate = urlSearchParams.get("taskDate");
    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("completedTaskType");
    const categoryParam = urlSearchParams.get("taskCategories");

    if (userById) {
      let selectedPriorities: any[] = [];
      if (priorityParam) {
        const priorities = priorityParam.split("|");
        selectedPriorities = priorities.map((value) => ({
          priority: value.toUpperCase(),
        }));
      }

      let selectedTypes: any[] = [];
      if (typeParam) {
        const types = typeParam.split("|");
        selectedTypes = types.map((value) => ({ type: value }));
      }

      let selectedCategories: any[] = [];
      if (categoryParam) {
        const categories = categoryParam.split("|");
        selectedCategories = categories
          .map((value) => {
            const category = [
              { category: "Student Task" },
              { category: "General Task" },
              { category: "Payment Overdue Task" },
            ].find(
              (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
            );
            return category
              ? {
                category: category.category,
              }
              : null;
          })
          .filter(Boolean);
      }

      const formattedCategories =
        selectedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [];

      if (taskDate && taskDate !== null) {
        const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
        const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();
        setSelectedDate(parseInt(taskDate));

        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          startDate,
          endDate,
          selectedUsersParam ? selectedUsersParam : "",
          event.target.value,
          selectedPriorities,
          selectedTypes,
          0,
          0,
          formattedCategories,
        );
      } else {
        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          0,
          0,
          selectedUsersParam ? selectedUsersParam : "",
          event.target.value,
          selectedPriorities,
          selectedTypes,
          0,
          0,
          formattedCategories,
        );
      }
    }
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("taskLeadSearch", event.target.value);
    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  };

  const taskBoardApiCall = useCallback(
    (
      instituteId: string,
      taskStartDate: any,
      taskEndDate: any,
      userId: any,
      searchText?: any,
      prioritiesArray?: any,
      typeArray?: any,
      startDateForFilter?: any,
      endDateForFilter?: any,
      categoryArray?: any,
    ) => {
      const data: any = {
        instituteId: instituteId,
        startDate: taskStartDate,
        endDate: taskEndDate,
        getTasks: true,
        entityName: "TASK",
        priority: prioritiesArray,
        taskType: typeArray,
        searchText: searchText ? searchText : "",
        filterStartDate: startDateForFilter ? startDateForFilter : 0,
        filterEndDate: endDateForFilter ? endDateForFilter : 0,
      };

      if (categoryArray && categoryArray.length > 0) {
        data.taskCategory = categoryArray;
      }

      if (!hasAllBranchAccess) {
        data.branchId = userById?.branchId;
      }

      if (hasAllTaskAccess && userId !== "") {
        data.userId = userId;
      } else if (!hasAllTaskAccess) {
        data.userId = authUser?.institute[0]?.id;
      }

      data.lanesToFetch = [
        {
          status: "COMPLETED",
        },
      ];
      GetTasksBoard(data);
    },
    [hasAllTaskAccess, userById, hasAllBranchAccess],
  );

  const handleDateChange = (date: any) => {
    if (date !== null) {
      const dateUnix = date.unix() * 1000;
      setSelectedDate(dateUnix);

      const selectedDateFirstMinute = moment(dateUnix).startOf("day").valueOf();
      const selectedDateLastMinute = moment(dateUnix).endOf("day").valueOf();

      const urlSearchParams = new URLSearchParams(window.location.search);
      const priorityParam = urlSearchParams.get("taskPriorities");
      const typeParam = urlSearchParams.get("completedTaskType");
      const categoryParam = urlSearchParams.get("taskCategories");
      const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

      let selectedPriorities: any[] = [];
      if (priorityParam) {
        const priorities = priorityParam.split("|");
        selectedPriorities = priorities.map((value) => ({
          priority: value.toUpperCase(),
        }));
      }

      let selectedTypes: any[] = [];
      if (typeParam) {
        const types = typeParam.split("|");
        selectedTypes = types.map((value) => ({ type: value }));
      }

      let selectedCategories: any[] = [];
      if (categoryParam) {
        const categories = categoryParam.split("|");
        selectedCategories = categories
          .map((value) => {
            const category = [
              { category: "Student Task" },
              { category: "General Task" },
              { category: "Payment Overdue Task" },
            ].find(
              (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
            );
            return category
              ? {
                category: category.category,
              }
              : null;
          })
          .filter(Boolean);
      }

      const formattedCategories =
        selectedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [];

      taskBoardApiCall(
        authUser?.institute[0]?.instituteDetails?.id,
        selectedDateFirstMinute,
        selectedDateLastMinute,
        selectedTeamMember?.length > 0
          ? selectedTeamMember.map((m: any) => String(m.id))
          : "",
        taskLeadSearchInUrl || "",
        selectedPriorities,
        selectedTypes,
        0,
        0,
        formattedCategories,
      );

      const queryParams = new URLSearchParams(window.location.search);
      if (dateUnix) {
        queryParams.set("taskDate", dateUnix.toString());

        const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
        window.history.pushState({}, "", newUrl);
      }
    }
  };

  const handleResetDate = useCallback(() => {
    setSelectedDate(null);

    const urlSearchParams = new URLSearchParams(window.location.search);
    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("completedTaskType");
    const categoryParam = urlSearchParams.get("taskCategories");
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

    let selectedPriorities: any[] = [];
    if (priorityParam) {
      const priorities = priorityParam.split("|");
      selectedPriorities = priorities.map((value) => ({
        priority: value.toUpperCase(),
      }));
    }

    let selectedTypes: any[] = [];
    if (typeParam) {
      const types = typeParam.split("|");
      selectedTypes = types.map((value) => ({ type: value }));
    }

    let selectedCategories: any[] = [];
    if (categoryParam) {
      const categories = categoryParam.split("|");
      selectedCategories = categories
        .map((value) => {
          const category = [
            { category: "Student Task" },
            { category: "General Task" },
            { category: "Payment Overdue Task" },
          ].find(
            (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
          );
          return category
            ? {
              category: category.category,
            }
            : null;
        })
        .filter(Boolean);
    }

    const formattedCategories =
      selectedCategories?.map((item: any) => ({
        taskCategory: formatTaskCategory(item.category),
      })) || [];

    taskBoardApiCall(
      authUser?.institute[0]?.instituteDetails?.id,
      0,
      0,
      selectedTeamMember?.length > 0
        ? selectedTeamMember.map((m: any) => String(m.id))
        : "",
      taskLeadSearchInUrl || "",
      selectedPriorities,
      selectedTypes,
      0,
      0,
      formattedCategories,
    );
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.delete("taskDate");

    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  }, [setSelectedDate, selectedTeamMember, taskBoardApiCall, authUser]);

  const handleNextPage = (currentLaneStatus: any) => {
    const userFromLocalStorage = authUser?.institute[0]?.instituteDetails;
    const urlSearchParams = new URLSearchParams(window.location.search);
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const taskDate = urlSearchParams.get("taskDate");
    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("completedTaskType");
    const categoryParam = urlSearchParams.get("taskCategories");
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

    let startingDate = null;
    let endingDate = null;
    if (taskDate && taskDate !== null) {
      startingDate = moment(parseInt(taskDate)).startOf("day").valueOf();
      endingDate = moment(parseInt(taskDate)).endOf("day").valueOf();
    } else {
      startingDate = 0;
      endingDate = 0;
    }

    let selectedPriorities: any[] = [];
    if (priorityParam) {
      const priorities = priorityParam.split("|");
      selectedPriorities = priorities
        .map((value) => {
          const priority = [
            { priority: "URGENT" },
            { priority: "HIGH" },
            { priority: "NORMAL" },
            { priority: "LOW" },
          ].find(
            (type: any) => type.priority.toLowerCase() === value.toLowerCase(),
          );
          return priority ? { priority: priority.priority } : null;
        })
        .filter(Boolean);
    }

    let selectedTypes: any[] = [];
    if (typeParam && tasksTypes) {
      const types = typeParam.split("|");
      selectedTypes = types
        .map((value) => {
          const type = tasksTypes?.find(
            (taskType: any) =>
              taskType.taskTypeName.toLowerCase() === value.toLowerCase(),
          );
          return type ? { type: type.taskTypeName } : null;
        })
        .filter(Boolean);
    }

    let selectedCategories: any[] = [];
    if (categoryParam) {
      const categories = categoryParam.split("|");
      selectedCategories = categories
        .map((value) => {
          const category = [
            { category: "Student Task" },
            { category: "General Task" },
            { category: "Payment Overdue Task" },
          ].find(
            (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
          );
          return category ? { category: category.category } : null;
        })
        .filter(Boolean);
    }

    const formattedCategories =
      selectedCategories?.map((item: any) => ({
        taskCategory: formatTaskCategory(item.category),
      })) || [];

    const evaluatedKeysForLanes: any =
      taskItems &&
      taskItems
        ?.filter((d: any) => d?.stateName === currentLaneStatus)
        ?.map((d: any) => {
          return {
            status: currentLaneStatus,
            searchAfter: d?.tasks?.searchAfter,
          };
        });

    const data: any = {
      instituteId: userFromLocalStorage?.id,
      startDate: startingDate,
      endDate: endingDate,
      limit: 15,
      lanesToFetch: evaluatedKeysForLanes,
      getTasks: true,
      entityName: "TASK",
      priority: selectedPriorities,
      taskType: selectedTypes,
      searchText: taskLeadSearchInUrl ? taskLeadSearchInUrl : "",
    };

    if (formattedCategories && formattedCategories.length > 0) {
      data.taskCategory = formattedCategories;
    }

    if (!hasAllBranchAccess) {
      data.branchId = userById?.branchId;
    }
    if (hasAllTaskAccess && selectedUsersParam) {
      data.userId = selectedUsersParam;
    } else if (!hasAllTaskAccess) {
      data.userId = authUser?.institute[0]?.id;
    }

    GetTaskBoard(data).then((res: any) => {
      const result = res?.data?.data;
      const updatedState = taskItems?.map((oldObject: any) => {
        const correspondingResult = result?.find(
          (r: any) => r.stateName === oldObject.stateName,
        );

        if (correspondingResult) {
          const updatedTasks = [...oldObject.tasks?.data];

          correspondingResult?.tasks?.data?.forEach((newTask: any) => {
            if (!updatedTasks?.find((task) => task.id === newTask.id)) {
              updatedTasks.push(newTask);
            }
          });

          return {
            ...oldObject,
            tasks: {
              data: updatedTasks,
              hasMore: correspondingResult?.tasks?.hasMore,
              searchAfter: correspondingResult?.tasks?.searchAfter,
            },
          };
        } else {
          return oldObject;
        }
      });
      setTaskItems(updatedState);
    });
  };

  const handleTeamMemberSelect = (emp: any) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskDate = urlSearchParams.get("taskDate");
    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("completedTaskType");
    const categoryParam = urlSearchParams.get("taskCategories");
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

    let startingDate: any | null = null;
    let endingDate: any | null = null;

    if (taskDate && taskDate !== null) {
      startingDate = moment(parseInt(taskDate)).startOf("day").valueOf();
      endingDate = moment(parseInt(taskDate)).endOf("day").valueOf();
    } else {
      startingDate = 0;
      endingDate = 0;
    }

    let selectedPriorities: any[] = [];
    if (priorityParam) {
      const priorities = priorityParam.split("|");
      selectedPriorities = priorities.map((value) => ({
        priority: value.toUpperCase(),
      }));
    }

    let selectedTypes: any[] = [];
    if (typeParam) {
      const types = typeParam.split("|");
      selectedTypes = types.map((value) => ({ type: value }));
    }

    let selectedCategories: any[] = [];
    if (categoryParam) {
      const categories = categoryParam.split("|");
      selectedCategories = categories
        .map((value) => {
          const category = [
            { category: "Student Task" },
            { category: "General Task" },
            { category: "Payment Overdue Task" },
          ].find(
            (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
          );
          return category
            ? {
              category: category.category,
            }
            : null;
        })
        .filter(Boolean);
    }

    const formattedCategories =
      selectedCategories?.map((item: any) => ({
        taskCategory: formatTaskCategory(item.category),
      })) || [];

    setSelectedTeamMember((prevSelected: any) => {
      if (prevSelected?.length > 0 && prevSelected?.[0].id === emp?.id) {
        if (startingDate !== null && endingDate !== null) {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startingDate,
            endingDate,
            "",
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            0,
            0,
            formattedCategories,
          );
        }

        return [];
      } else {
        if (startingDate !== null && endingDate !== null && emp?.id) {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startingDate,
            endingDate,
            emp?.id,
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            0,
            0,
            formattedCategories,
          );
        }
        return [emp];
      }
    });

    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.get("selectedUsers") === emp.id) {
      queryParams.delete("selectedUsers");
    } else {
      queryParams.set("selectedUsers", emp.id);
    }

    const newUrl = `${window.location.pathname}?${queryParams.toString()}`;
    window.history.pushState({}, "", newUrl);
  };

  interface CheckedPriorities {
    priority: string;
  }
  interface CheckedTypes {
    type: string;
  }
  interface CheckedCategories {
    category: string;
  }
  const [checkedPriorities, setCheckedPriorities] = useState<
    CheckedPriorities[]
  >([]);
  const [filterCheckedPriorities, setFilterCheckedPriorities] = useState<
    CheckedPriorities[]
  >([]);
  const [checkedTypes, setCheckedTypes] = useState<CheckedTypes[]>([]);
  const [filterCheckedTypes, setFilterCheckedTypes] = useState<CheckedTypes[]>(
    [],
  );
  const [checkedCategories, setCheckedCategories] = useState<
    CheckedCategories[]
  >([]);
  const [filterCheckedCategories, setFilterCheckedCategories] = useState<
    CheckedCategories[]
  >([]);

  const handleFilterPriorityChecked = (priority: string) => {
    const priorityToAdd: CheckedPriorities = { priority };

    if (
      checkedPriorities.some(
        (item) => item.priority.toLowerCase() === priority.toLowerCase(),
      )
    ) {
      setCheckedPriorities(
        checkedPriorities.filter(
          (item) => item.priority.toLowerCase() !== priority.toLowerCase(),
        ),
      );
    } else {
      setCheckedPriorities([...checkedPriorities, priorityToAdd]);
    }
  };

  const clearCheckedPriority = (priority: string) => {
    setCheckedPriorities(
      checkedPriorities.filter(
        (item) => item.priority.toLowerCase() !== priority.toLowerCase(),
      ),
    );
  };

  const handleFilterTypeChecked = (type: string) => {
    const typeToAdd: CheckedTypes = { type };

    if (
      checkedTypes.some(
        (item) => item.type.toLowerCase() === type.toLowerCase(),
      )
    ) {
      setCheckedTypes(
        checkedTypes.filter(
          (item) => item.type.toLowerCase() !== type.toLowerCase(),
        ),
      );
    } else {
      setCheckedTypes([...checkedTypes, typeToAdd]);
    }
  };

  const clearCheckedType = (type: string) => {
    setCheckedTypes(
      checkedTypes.filter(
        (item) => item.type.toLowerCase() !== type.toLowerCase(),
      ),
    );
  };

  const handleFilterCategoryChecked = (category: string) => {
    const categoryToAdd: CheckedCategories = { category };

    if (
      checkedCategories.some(
        (item) => item.category.toLowerCase() === category.toLowerCase(),
      )
    ) {
      setCheckedCategories(
        checkedCategories.filter(
          (item) => item.category.toLowerCase() !== category.toLowerCase(),
        ),
      );
    } else {
      setCheckedCategories([...checkedCategories, categoryToAdd]);
    }
  };

  const clearCheckedCategory = (category: string) => {
    setCheckedCategories(
      checkedCategories.filter(
        (item) => item.category.toLowerCase() !== category.toLowerCase(),
      ),
    );
  };

  const filteredTasks =
    taskList &&
    completedTasks?.tasks?.data
      ?.filter((task: any) => {
        const isGeneralTask =
          task?.taskCategory?.toUpperCase() === "GENERAL_TASK";
        const searchTermMatch = isGeneralTask
          ? (task.description?.toLowerCase() || "").includes(
            leadSearchTerm.toLowerCase(),
          ) ||
          (task.taskTitle?.toLowerCase() || "").includes(
            leadSearchTerm.toLowerCase(),
          ) ||
          (task.assignedToName?.toLowerCase() || "").includes(
            leadSearchTerm.toLowerCase(),
          )
          : (task.studentName?.toLowerCase() || "").indexOf(
            leadSearchTerm.toLowerCase(),
          ) !== -1;

        const typeIsChecked =
          filterCheckedTypes.length === 0 ||
          filterCheckedTypes.some(
            (item) =>
              item.type.toLowerCase() === (task.taskType?.toLowerCase() || ""),
          );

        const priorityIsChecked =
          filterCheckedPriorities.length === 0 ||
          filterCheckedPriorities.some(
            (item) =>
              item.priority.toLowerCase() ===
              (task.priority?.toLowerCase() || ""),
          );

        const additionalSearchTermCondition =
          task?.taskType === "DEMO" && task?.demoData?.[0]?.batchName
            ? task?.demoData?.[0]?.batchName
              .toLowerCase()
              .includes(leadSearchTerm.toLowerCase())
            : true;

        return (
          searchTermMatch &&
          typeIsChecked &&
          additionalSearchTermCondition &&
          priorityIsChecked
        );
      })
      ?.sort((a: any, b: any) => {
        const dateA = a?.taskCompletedDate || a?.date || 0;
        const dateB = b?.taskCompletedDate || b?.date || 0;
        return dateB - dateA;
      });

  const handleFilterTasks = React.useCallback(
    (typesArray: any, prioritiesArray: any, categoryArray?: any) => {
      setFilterCheckedTypes(typesArray);
      setFilterCheckedPriorities(prioritiesArray);
      setFilterCheckedCategories(categoryArray || []);

      const urlSearchParams = new URLSearchParams(window.location.search);

      const selectedUsersParam = urlSearchParams.get("selectedUsers");
      const taskDate = urlSearchParams.get("taskDate");
      const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

      const formattedCategoryArray =
        categoryArray?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [];

      if (userById) {
        if (taskDate && taskDate !== null) {
          const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
          const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();
          setSelectedDate(parseInt(taskDate));

          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startDate,
            endDate,
            selectedUsersParam ? selectedUsersParam : "",
            taskLeadSearchInUrl || "",
            prioritiesArray,
            typesArray,
            0,
            0,
            formattedCategoryArray,
          );
        } else {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            0,
            0,
            selectedUsersParam ? selectedUsersParam : "",
            taskLeadSearchInUrl || "",
            prioritiesArray,
            typesArray,
            0,
            0,
            formattedCategoryArray,
          );
        }
      }
      const queryParams = new URLSearchParams(window.location.search);
      if (typesArray && typesArray.length > 0) {
        const statusParam = typesArray.map((item: any) => item.type).join("|");
        queryParams.set("completedTaskType", statusParam);
      } else {
        queryParams.delete("completedTaskType");
      }

      if (prioritiesArray && prioritiesArray.length > 0) {
        const priorityParam = prioritiesArray
          .map((item: any) => item.priority)
          .join("|");
        queryParams.set("taskPriorities", priorityParam);
      } else {
        queryParams.delete("taskPriorities");
      }

      if (categoryArray && categoryArray.length > 0) {
        const categoryParam = categoryArray
          .map((item: any) => item.category)
          .join("|");
        queryParams.set("taskCategories", categoryParam);
      } else {
        queryParams.delete("taskCategories");
      }

      const queryString = queryParams.toString();
      const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ""
        }`;

      window.history.pushState({}, "", newUrl);
    },
    [
      setFilterCheckedTypes,
      setFilterCheckedPriorities,
      setFilterCheckedCategories,
    ],
  );

  const handleFilterApply = React.useCallback(() => {
    handleFilterTasks(checkedTypes, checkedPriorities, checkedCategories);

    setFilterApplied(
      checkedPriorities?.length === 0 &&
        checkedTypes?.length === 0 &&
        checkedCategories?.length === 0
        ? false
        : true,
    );
  }, [
    handleFilterTasks,
    checkedTypes,
    setFilterApplied,
    checkedPriorities,
    checkedCategories,
  ]);

  const handleResetClick = React.useCallback(() => {
    handleFilterTasks([], [], []);
    setCheckedTypes([]);
    setCheckedPriorities([]);
    setCheckedCategories([]);
    setFilterApplied(false);
  }, [
    handleFilterTasks,
    setFilterApplied,
    setCheckedTypes,
    setCheckedPriorities,
    setCheckedCategories,
  ]);

  const handleFilterClose = React.useCallback(() => {
    setCheckedTypes(filterCheckedTypes);
    setCheckedPriorities(filterCheckedPriorities);
    setCheckedCategories(filterCheckedCategories || []);
  }, [filterCheckedTypes, filterCheckedPriorities, filterCheckedCategories]);

  const cancelClick = () => {
    setIsOpenFilter(true);
  };

  const closeClearFilter = () => {
    setIsOpenFilter(false);
  };

  const yesButtonClick = () => {
    handleResetClick();
    setIsOpenFilter(false);
    setFilterApplied(false);
  };

  const noButtonClick = () => {
    setIsOpenFilter(false);
  };

  const handleTaskClick = (task: any) => {
    if (task?.taskCategory?.toUpperCase() === "GENERAL_TASK") {
      const taskId = task.id || task.activityId;
      if (taskId) {
        setSelectedGeneralTaskId(taskId);
        dispatch(
          getTaskById({ id: taskId, taskCategory: "GENERAL_TASK" }) as any,
        )
          .unwrap()
          .catch((err: { status?: number; message?: string }) => {
            if (err?.status === 404) {
              setSelectedGeneralTaskId(null);
              dispatch(resetTaskById());
              dispatch(
                setToastNotification({
                  message:
                    err?.message || "Task not found. It may have been deleted.",
                  type: "error",
                  snackOpen: true,
                }),
              );
              setTimeout(() => {
                const urlSearchParams = new URLSearchParams(
                  window.location.search,
                );
                const taskDate = urlSearchParams.get("taskDate");
                const selectedUsersParam = urlSearchParams.get("selectedUsers");
                const formattedCategories =
                  filterCheckedCategories?.map((item: any) => ({
                    taskCategory: formatTaskCategory(item.category),
                  })) || [];
                if (userById && authUser?.institute[0]?.instituteDetails?.id) {
                  if (taskDate && taskDate !== null) {
                    const startDate = moment(parseInt(taskDate))
                      .startOf("day")
                      .valueOf();
                    const endDate = moment(parseInt(taskDate))
                      .endOf("day")
                      .valueOf();
                    taskBoardApiCall(
                      authUser.institute[0].instituteDetails.id,
                      startDate,
                      endDate,
                      selectedUsersParam ? selectedUsersParam : "",
                      leadSearchTerm,
                      filterCheckedPriorities,
                      filterCheckedTypes,
                      0,
                      0,
                      formattedCategories,
                    );
                  } else {
                    taskBoardApiCall(
                      authUser.institute[0].instituteDetails.id,
                      0,
                      0,
                      selectedUsersParam ? selectedUsersParam : "",
                      leadSearchTerm,
                      filterCheckedPriorities,
                      filterCheckedTypes,
                      0,
                      0,
                      formattedCategories,
                    );
                  }
                }
              }, 500);
            }
          });
      }
    }
  };

  const handleCloseDrawer = () => {
    setSelectedGeneralTaskId(null);
    dispatch(resetTaskById());

    setTimeout(() => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const taskDate = urlSearchParams.get("taskDate");
      const selectedUsersParam = urlSearchParams.get("selectedUsers");

      if (userById) {
        const formattedCategories =
          filterCheckedCategories?.map((item: any) => ({
            taskCategory: formatTaskCategory(item.category),
          })) || [];

        if (taskDate && taskDate !== null) {
          const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
          const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();

          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startDate,
            endDate,
            selectedUsersParam ? selectedUsersParam : "",
            leadSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            0,
            0,
            formattedCategories,
          );
        } else {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            0,
            0,
            selectedUsersParam ? selectedUsersParam : "",
            leadSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            0,
            0,
            formattedCategories,
          );
        }
      }
    }, 800);
  };

  useEffect(() => {
    if (deleteTaskSuccess && deleteTaskSuccess !== false) {
      if (selectedGeneralTaskId) {
        setSelectedGeneralTaskId(null);
        dispatch(resetTaskById());
      }

      const urlSearchParams = new URLSearchParams(window.location.search);
      const taskDate = urlSearchParams.get("taskDate");
      const selectedUsersParam = urlSearchParams.get("selectedUsers");

      if (userById) {
        const formattedCategories =
          filterCheckedCategories?.map((item: any) => ({
            taskCategory: formatTaskCategory(item.category),
          })) || [];

        const isGeneralTaskOperation =
          lastDeletedTaskCategory?.toUpperCase() === "GENERAL_TASK";

        if (taskDate && taskDate !== null) {
          const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
          const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();

          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startDate,
            endDate,
            selectedUsersParam ? selectedUsersParam : "",
            leadSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            0,
            0,
            formattedCategories,
          );
          if (isGeneralTaskOperation) {
            setTimeout(() => {
              taskBoardApiCall(
                authUser?.institute[0]?.instituteDetails?.id,
                startDate,
                endDate,
                selectedUsersParam ? selectedUsersParam : "",
                leadSearchTerm,
                filterCheckedPriorities,
                filterCheckedTypes,
                0,
                0,
                formattedCategories,
              );
            }, 100);
          }
        } else {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            0,
            0,
            selectedUsersParam ? selectedUsersParam : "",
            leadSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            0,
            0,
            formattedCategories,
          );
          if (isGeneralTaskOperation) {
            setTimeout(() => {
              taskBoardApiCall(
                authUser?.institute[0]?.instituteDetails?.id,
                0,
                0,
                selectedUsersParam ? selectedUsersParam : "",
                leadSearchTerm,
                filterCheckedPriorities,
                filterCheckedTypes,
                0,
                0,
                formattedCategories,
              );
            }, 100);
          }
        }
      }

      setTimeout(() => {
        dispatch(resetDeleteTaskSuccess());
      }, 100);
    }
  }, [
    deleteTaskSuccess,
    selectedGeneralTaskId,
    dispatch,
    userById,
    authUser,
    leadSearchTerm,
    filterCheckedPriorities,
    filterCheckedTypes,
    filterCheckedCategories,
    taskBoardApiCall,
    lastDeletedTaskCategory,
  ]);

  useEffect(() => {
    const isEditSuccess = editTaskSuccess !== true && editTaskSuccess !== false;

    if (isEditSuccess && userById) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const taskDate = urlSearchParams.get("taskDate");
      const selectedUsersParam = urlSearchParams.get("selectedUsers");

      const formattedCategories =
        filterCheckedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [];

      setTimeout(() => {
        const isGeneralTaskOperation =
          lastEditedTaskCategory?.toUpperCase() === "GENERAL_TASK";

        if (taskDate && taskDate !== null) {
          const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
          const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();

          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startDate,
            endDate,
            selectedUsersParam ? selectedUsersParam : "",
            leadSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            0,
            0,
            formattedCategories,
          );
          if (isGeneralTaskOperation) {
            setTimeout(() => {
              taskBoardApiCall(
                authUser?.institute[0]?.instituteDetails?.id,
                startDate,
                endDate,
                selectedUsersParam ? selectedUsersParam : "",
                leadSearchTerm,
                filterCheckedPriorities,
                filterCheckedTypes,
                0,
                0,
                formattedCategories,
              );
            }, 100);
          }
        } else {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            0,
            0,
            selectedUsersParam ? selectedUsersParam : "",
            leadSearchTerm,
            filterCheckedPriorities,
            filterCheckedTypes,
            0,
            0,
            formattedCategories,
          );
          if (isGeneralTaskOperation) {
            setTimeout(() => {
              taskBoardApiCall(
                authUser?.institute[0]?.instituteDetails?.id,
                0,
                0,
                selectedUsersParam ? selectedUsersParam : "",
                leadSearchTerm,
                filterCheckedPriorities,
                filterCheckedTypes,
                0,
                0,
                formattedCategories,
              );
            }, 100);
          }
        }

        if (lastCreatedTaskId) {
          setTimeout(() => {
            setHighlightedTaskId(lastCreatedTaskId);

            const scrollToTask = (retries = 0) => {
              const taskElement = document.getElementById(
                `task-${lastCreatedTaskId}`,
              );
              if (taskElement) {
                taskElement.scrollIntoView({
                  behavior: "auto",
                  block: "nearest",
                  inline: "nearest",
                });

                setTimeout(() => {
                  const scrollableParent =
                    taskElement.closest('[class*="taskCompletedListWrap"]') ||
                    document.querySelector('[class*="taskCompletedListWrap"]');

                  if (scrollableParent) {
                    const elementRect = taskElement.getBoundingClientRect();
                    const parentRect = scrollableParent.getBoundingClientRect();
                    const scrollTop = scrollableParent.scrollTop;

                    const elementCenter =
                      elementRect.top + elementRect.height / 2;
                    const parentCenter = parentRect.top + parentRect.height / 2;
                    const offset = elementCenter - parentCenter;
                    const targetScrollTop = scrollTop + offset;

                    scrollableParent.scrollTo({
                      top: Math.max(0, targetScrollTop),
                      behavior: "smooth",
                    });
                  } else {
                    taskElement.scrollIntoView({
                      behavior: "smooth",
                      block: "center",
                      inline: "nearest",
                    });
                  }
                }, 100);
              } else if (retries < 10) {
                setTimeout(() => scrollToTask(retries + 1), 400);
              }
            };

            setTimeout(() => scrollToTask(), 500);

            setTimeout(() => {
              setHighlightedTaskId(null);
            }, 5000);
          }, 1200);
        }
      }, 500);
    }
  }, [
    editTaskSuccess,
    userById,
    authUser,
    leadSearchTerm,
    filterCheckedPriorities,
    filterCheckedTypes,
    filterCheckedCategories,
    taskBoardApiCall,
    lastCreatedTaskId,
    lastEditedTaskCategory,
  ]);

  const filteredValue = (
    <>
      {filterCheckedPriorities?.length > 0 &&
        filterCheckedPriorities?.map((item) => (
          <div key={item.priority} className="filteredDiv">
            {item.priority.toLowerCase()}
          </div>
        ))}
      {filterCheckedTypes?.length > 0 &&
        filterCheckedTypes?.map((item) => (
          <div key={item.type} className="filteredDiv">
            {item.type?.toLowerCase()}
          </div>
        ))}
      {filterCheckedCategories?.length > 0 &&
        filterCheckedCategories?.map((item) => (
          <div key={item.category} className="filteredDiv">
            {item.category?.toLowerCase()}
          </div>
        ))}
    </>
  );

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const priorityParam = urlSearchParams.get("taskPriorities");
    const categoryParam = urlSearchParams.get("taskCategories");
    const typeParam = urlSearchParams.get("completedTaskType");
    const taskDate = urlSearchParams.get("taskDate");

    if (priorityParam) {
      const priorities = priorityParam.split("|");

      const selectedPriorities = priorities
        .map((value) => {
          const priority = [
            { priority: "URGENT" },
            { priority: "HIGH" },
            { priority: "NORMAL" },
            { priority: "LOW" },
          ].find(
            (type: any) => type.priority.toLowerCase() === value.toLowerCase(),
          );
          return priority
            ? {
              priority: priority.priority,
            }
            : null;
        })
        .filter(Boolean) as CheckedPriorities[];

      setFilterCheckedPriorities(selectedPriorities);
      setCheckedPriorities(selectedPriorities);
    }

    if (categoryParam) {
      const categories = categoryParam.split("|");

      const selectedCategories = categories
        .map((value) => {
          const category = [
            { category: "Student Task" },
            { category: "General Task" },
            { category: "Payment Overdue Task" },
          ].find(
            (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
          );
          return category
            ? {
              category: category.category,
            }
            : null;
        })
        .filter(Boolean) as CheckedCategories[];

      setCheckedCategories(selectedCategories);
      setFilterCheckedCategories(selectedCategories);
    }

    if (typeParam && tasksTypes && tasksTypes.length > 0) {
      const types = typeParam.split("|");

      const selectedTypes = types
        .map((value) => {
          const type = tasksTypes.find(
            (taskType: any) =>
              taskType.taskTypeName.toLowerCase() === value.toLowerCase(),
          );
          return type
            ? {
              type: type.taskTypeName,
            }
            : null;
        })
        .filter(Boolean) as CheckedTypes[];

      if (selectedTypes.length > 0) {
        setCheckedTypes(selectedTypes);
        setFilterCheckedTypes(selectedTypes);
      }
    }

    if (taskDate && taskDate !== null) {
      setSelectedDate(parseInt(taskDate));
    }

    if (priorityParam || categoryParam || typeParam) {
      setFilterApplied(true);
    }
  }, [tasksTypes]);

  useEffect(() => {
    if (taskList) {
      setTaskItems(taskList);
    } else {
      setTaskItems([]);
    }
  }, [taskList]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    if (employees?.length > 0) {
      const staff = employees
        ?.filter((item: any) => item?.status === "ACTIVE")
        ?.find((item: any) => item.id === selectedUsersParam);
      if (staff) {
        setSelectedTeamMember([staff]);
      } else {
        setSelectedTeamMember([]);
      }
    }
  }, [employees]);

  React.useEffect(() => {
    if (Array.isArray(taskItems)) {
      const evaluatedKeysForLanes = taskItems?.map((d) => {
        return {
          status: d?.status,
          lastEvaluatedKey: d?.lastEvaluatedKey ? d?.lastEvaluatedKey : "",
          lastEvaluatedSortKey: d?.lastEvaluatedSortKey
            ? d?.lastEvaluatedSortKey
            : "",
        };
      });

      const hasEvaluatedKey = evaluatedKeysForLanes.some(
        (ds) => ds.lastEvaluatedKey !== "",
      );

      setHasMoreData(hasEvaluatedKey);
    } else {
      setHasMoreData(false);
    }
  }, [taskItems]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskDate = urlSearchParams.get("taskDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("completedTaskType");
    const categoryParam = urlSearchParams.get("taskCategories");

    if (urlSearchParams.has("taskLeadSearch")) {
      urlSearchParams.delete("taskLeadSearch");
      const newUrl = `${window.location.pathname}${urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : ""}`;
      window.history.replaceState({}, "", newUrl);
      setLeadSearchTerm("");
    }

    if (userById) {
      let selectedPriorities: any[] = [];
      if (priorityParam) {
        const priorities = priorityParam.split("|");
        selectedPriorities = priorities.map((value) => ({
          priority: value.toUpperCase(),
        }));
      }

      let selectedTypes: any[] = [];
      if (typeParam) {
        const types = typeParam.split("|");
        selectedTypes = types.map((value) => ({ type: value }));
      }

      let selectedCategories: any[] = [];
      if (categoryParam) {
        const categories = categoryParam.split("|");
        selectedCategories = categories
          .map((value) => {
            const category = [
              { category: "Student Task" },
              { category: "General Task" },
              { category: "Payment Overdue Task" },
            ].find(
              (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
            );
            return category
              ? {
                category: category.category,
              }
              : null;
          })
          .filter(Boolean);
      }

      const formattedCategories =
        selectedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [];

      if (taskDate && taskDate !== null) {
        const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
        const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();
        setSelectedDate(parseInt(taskDate));

        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          startDate,
          endDate,
          selectedUsersParam ? selectedUsersParam : "",
          "",
          selectedPriorities,
          selectedTypes,
          0,
          0,
          formattedCategories,
        );
      } else {
        taskBoardApiCall(
          authUser?.institute[0]?.instituteDetails?.id,
          0,
          0,
          selectedUsersParam ? selectedUsersParam : "",
          "",
          selectedPriorities,
          selectedTypes,
          0,
          0,
          formattedCategories,
        );
      }
    }
  }, [userById]);

  React.useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const taskDate = urlSearchParams.get("taskDate");
    const selectedUsersParam = urlSearchParams.get("selectedUsers");
    const priorityParam = urlSearchParams.get("taskPriorities");
    const typeParam = urlSearchParams.get("completedTaskType");
    const categoryParam = urlSearchParams.get("taskCategories");
    const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

    const isTaskUpdateSuccess =
      (taskStatusUpdateSuccess !== true && taskStatusUpdateSuccess !== false) ||
      (taskPriorityUpdateSuccess !== true &&
        taskPriorityUpdateSuccess !== false) ||
      (taskAssigneeUpdateSuccess !== true &&
        taskAssigneeUpdateSuccess !== false);

    if (isTaskUpdateSuccess) {
      setTimeout(() => {
        let selectedPriorities: any[] = [];
        if (priorityParam) {
          const priorities = priorityParam.split("|");
          selectedPriorities = priorities.map((value) => ({
            priority: value.toUpperCase(),
          }));
        }

        let selectedTypes: any[] = [];
        if (typeParam) {
          const types = typeParam.split("|");
          selectedTypes = types.map((value) => ({ type: value }));
        }

        let selectedCategories: any[] = [];
        if (categoryParam) {
          const categories = categoryParam.split("|");
          selectedCategories = categories
            .map((value) => {
              const category = [
                { category: "Student Task" },
                { category: "General Task" },
                { category: "Payment Overdue Task" },
              ].find(
                (cat: any) =>
                  cat.category.toLowerCase() === value.toLowerCase(),
              );
              return category
                ? {
                  category: category.category,
                }
                : null;
            })
            .filter(Boolean);
        }

        let formattedCategories =
          selectedCategories?.map((item: any) => ({
            taskCategory: formatTaskCategory(item.category),
          })) || [];

        if (formattedCategories.length > 0) {
          const hasGeneralTask = formattedCategories.some(
            (c: any) =>
              c.taskCategory === "GENERAL_TASK" ||
              c.taskCategory === "General Task",
          );
          if (!hasGeneralTask) {
            formattedCategories = [
              ...formattedCategories,
              { taskCategory: "GENERAL_TASK" },
            ];
          }
        }

        if (taskDate && taskDate !== null) {
          const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
          const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();

          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startDate,
            endDate,
            selectedUsersParam ? selectedUsersParam : "",
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            0,
            0,
            formattedCategories,
          );
        } else {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            0,
            0,
            selectedUsersParam ? selectedUsersParam : "",
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            0,
            0,
            formattedCategories,
          );
        }

        dispatch(resetTaskUpdateSuccess());
      }, 1000);
    }
  }, [
    taskStatusUpdateSuccess,
    taskPriorityUpdateSuccess,
    taskAssigneeUpdateSuccess,
  ]);

  React.useEffect(() => {
    if (taskUpdateNotify === true && authUser?.institute) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const taskDate = urlSearchParams.get("taskDate");
      const selectedUsersParam = urlSearchParams.get("selectedUsers");
      const priorityParam = urlSearchParams.get("taskPriorities");
      const typeParam = urlSearchParams.get("completedTaskType");
      const categoryParam = urlSearchParams.get("taskCategories");
      const taskLeadSearchInUrl = urlSearchParams.get("taskLeadSearch");

      let selectedPriorities: any[] = [];
      if (priorityParam) {
        const priorities = priorityParam.split("|");
        selectedPriorities = priorities.map((value) => ({
          priority: value.toUpperCase(),
        }));
      }

      let selectedTypes: any[] = [];
      if (typeParam) {
        const types = typeParam.split("|");
        selectedTypes = types.map((value) => ({ type: value }));
      }

      let selectedCategories: any[] = [];
      if (categoryParam) {
        const categories = categoryParam.split("|");
        selectedCategories = categories
          .map((value) => {
            const category = [
              { category: "Student Task" },
              { category: "General Task" },
              { category: "Payment Overdue Task" },
            ].find(
              (cat: any) => cat.category.toLowerCase() === value.toLowerCase(),
            );
            return category ? { category: category.category } : null;
          })
          .filter(Boolean);
      }

      let formattedCategories =
        selectedCategories?.map((item: any) => ({
          taskCategory: formatTaskCategory(item.category),
        })) || [];

      if (formattedCategories.length > 0) {
        const hasGeneralTask = formattedCategories.some(
          (c: any) =>
            c.taskCategory === "GENERAL_TASK" ||
            c.taskCategory === "General Task",
        );
        if (!hasGeneralTask) {
          formattedCategories = [
            ...formattedCategories,
            { taskCategory: "GENERAL_TASK" },
          ];
        }
      }

      const userIdParam = selectedUsersParam
        ? selectedUsersParam.split(",").filter(Boolean)
        : selectedTeamMember?.length > 0
          ? selectedTeamMember.map((m: any) => String(m.id))
          : "";

      const refreshTimeoutId = setTimeout(() => {
        if (taskDate && taskDate !== null) {
          const startDate = moment(parseInt(taskDate)).startOf("day").valueOf();
          const endDate = moment(parseInt(taskDate)).endOf("day").valueOf();

          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            startDate,
            endDate,
            userIdParam,
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            0,
            0,
            formattedCategories,
          );
        } else {
          taskBoardApiCall(
            authUser?.institute[0]?.instituteDetails?.id,
            0,
            0,
            userIdParam,
            taskLeadSearchInUrl || "",
            selectedPriorities,
            selectedTypes,
            0,
            0,
            formattedCategories,
          );
        }

        setTimeout(() => {
          dispatch(clearTaskBoardRefresh());
        }, 5000);
      });

      return () => clearTimeout(refreshTimeoutId);
    }
  }, [
    taskUpdateNotify,
    authUser,
    taskBoardApiCall,
    dispatch,
    selectedTeamMember,
  ]);

  return (
    <div className={styles.pageWrap}>
      <div className={styles.pageWrapChild} style={{ display: "flex" }}>
        <div style={{ width: "calc( 100% - 360px)", padding: "22PX 30PX" }}>
          {completedTasks !== null ? (
            <>
              <div>
                <button
                  className={styles.completedTaskPageBackBtn}
                  onClick={handleGoBack}
                >
                  <ArrowBackIcon
                    sx={{
                      marginRight: "8px",
                      fontSize: "15PX",
                      color: "#667085",
                    }}
                  />
                  Back
                </button>
              </div>
              <h5 className={styles.completedTaskHead}>Completed tasks</h5>
              <div className={styles.completedTaskTopSplit}>
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <TextField
                      type="search"
                      value={leadSearchTerm}
                      onChange={handleLeadSearch}
                      placeholder="Search Tasks"
                      style={{
                        padding: "0px",
                        borderRadius: "4px",
                        border: "none",
                        outline: "none",
                        height: "38px",
                      }}
                      size="small"
                      inputProps={{
                        sx: {
                          width: "250px",
                          "&::placeholder": {
                            fontWeight: "400",
                            fontSize: "14px",
                          },

                          "& .MuiOutlinedInput-input": {
                            padding: "10.5px 14px",
                          },
                        },
                      }}
                    />
                    {hasAllTaskAccess && employees?.length > 0 && (
                      <UserAvatarGroup
                        handleItemSelect={handleTeamMemberSelect}
                        selectedItem={selectedTeamMember}
                      />
                    )}
                  </div>
                  <FilterDrawer
                    handleFilterApply={handleFilterApply}
                    handleResetClick={handleResetClick}
                    activeFilter={filterApplied}
                    cancelClick={cancelClick}
                    closeSetFilter={handleFilterClose}
                  >
                    <div
                      style={{
                        padding: "22px 32px",
                        overflowY: "auto",
                        maxHeight: "calc(100% - 110px)",
                      }}
                    >
                      <FilterChipsWrap>
                        {checkedPriorities.length > 0 &&
                          checkedPriorities.map((item) => (
                            <FilterChips
                              key={item.priority}
                              keyVal={item.priority}
                              chipName={item.priority.toLowerCase()}
                              clearValue={item.priority}
                              closeFunction={clearCheckedPriority}
                            />
                          ))}
                        {checkedTypes.length > 0 &&
                          checkedTypes.map((item) => (
                            <FilterChips
                              key={item.type}
                              keyVal={item.type}
                              chipName={item.type.toLowerCase()}
                              clearValue={item.type}
                              closeFunction={clearCheckedType}
                            />
                          ))}

                        {checkedCategories.length > 0 &&
                          checkedCategories.map((item) => (
                            <FilterChips
                              key={item.category}
                              keyVal={item.category}
                              chipName={item.category.toLowerCase()}
                              clearValue={item.category}
                              closeFunction={clearCheckedCategory}
                            />
                          ))}
                      </FilterChipsWrap>

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Priority" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {[
                              { priority: "URGENT" },
                              { priority: "HIGH" },
                              { priority: "NORMAL" },
                              { priority: "LOW" },
                            ].map((item: any) => (
                              <FilterCheckbox
                                key={item.priority}
                                keyVal={item.priority}
                                checked={checkedPriorities.some(
                                  (data) =>
                                    data.priority.toLowerCase() ===
                                    item.priority.toLowerCase(),
                                )}
                                checkboxFunction={() =>
                                  handleFilterPriorityChecked(item.priority)
                                }
                                label={item.priority.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Type" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {tasksTypes?.map((item: any) => (
                              <FilterCheckbox
                                key={item.id}
                                keyVal={item.id}
                                checked={checkedTypes.some(
                                  (data) =>
                                    data.type?.toLowerCase() ===
                                    item?.taskTypeName?.toLowerCase(),
                                )}
                                checkboxFunction={() =>
                                  handleFilterTypeChecked(item.taskTypeName)
                                }
                                label={item?.taskTypeName?.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>

                      <FilterTypeWrap>
                        <FilterLabel labelValue="Category" />
                        <FilterCheckBoxWrap>
                          <FormGroup>
                            {[
                              { category: "Student Task" },
                              { category: "General Task" },
                              { category: "Payment Overdue Task" },
                            ].map((item: any) => (
                              <FilterCheckbox
                                key={item.category}
                                keyVal={item.category}
                                checked={checkedCategories.some(
                                  (data) =>
                                    data.category.toLowerCase() ===
                                    item.category.toLowerCase(),
                                )}
                                checkboxFunction={() =>
                                  handleFilterCategoryChecked(item.category)
                                }
                                label={item.category.toLowerCase()}
                              />
                            ))}
                          </FormGroup>
                        </FilterCheckBoxWrap>
                      </FilterTypeWrap>
                    </div>
                  </FilterDrawer>
                </div>
              </div>
            </>
          ) : (
            <>
              <Skeleton
                animation="wave"
                variant="text"
                width="100px"
                height={15}
              />
              <Skeleton
                animation="wave"
                variant="text"
                width="200px"
                height={25}
                style={{ marginBottom: "8PX" }}
              />
              <Skeleton
                animation="wave"
                variant="rounded"
                width="99.4%"
                height={40}
                style={{ marginBottom: "15PX" }}
              />
            </>
          )}

          <div
            style={{
              maxHeight: "calc(100vh - 250px)",
              paddingRight: "5px",
              minHeight: "calc(100vh - 250px)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              position: "relative",
              overflowY: "hidden",
            }}
          >
            {completedTasks !== null && !taskBoardloading ? (
              <>
                {completedTasks && (
                  <InfiniteScroll
                    dataLength={completedTasks?.tasks?.data?.length}
                    next={() => handleNextPage(completedTasks?.stateName)}
                    hasMore={completedTasks?.tasks?.hasMore}
                    loader={
                      <Box
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {/* {<PuffLoader color="#36d7b7" />} */}
                      </Box>
                    }
                    height={"calc(100vh - 250px)"}
                  >
                    {taskList &&
                      filteredTasks?.map((task: any) => (
                        <CompletedCard
                          key={task.id}
                          taskCompletedPage={true}
                          task={task}
                          expandDisabled={false}
                          employees={employees}
                          page="COMPLETED_TASKS"
                          onTaskClick={handleTaskClick}
                          highlightedTaskId={highlightedTaskId}
                        />
                      ))}
                  </InfiniteScroll>
                )}
                {taskList && filteredTasks && filteredTasks?.length === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "absolute",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#667085",
                        textTransform: "capitalize",
                      }}
                    >
                      No data available
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <>
                {Array.from(new Array(4)).map((_, index) => (
                  <div
                    key={index}
                    className={styles.tableSkeletonBodyItem}
                    style={{ marginBottom: "10px" }}
                  >
                    <Skeleton
                      animation="wave"
                      variant="rounded"
                      width="100%"
                      height={100}
                    />
                  </div>
                ))}
              </>
            )}
          </div>
        </div>
        <div
          style={{ width: "360px", borderLeft: "1px solid #E9E9E9" }}
          className="datepicker-container"
        >
          {taskList ? (
            <>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StaticDatePicker
                  value={dayjs(selectedDate)}
                  onChange={(date: any) => handleDateChange(date)}
                  displayStaticWrapperAs="desktop"
                  disableFuture
                />
              </LocalizationProvider>
              {selectedDate !== null && (
                <div
                  style={{
                    margin: "0 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    marginBottom: "20px",
                    width: "310px",
                  }}
                >
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleResetDate}
                    sx={{
                      textTransform: "capitalize",
                      fontSize: "12px",
                      fontWeight: "500",
                    }}
                    size="small"
                  >
                    Reset Date
                  </Button>
                </div>
              )}
            </>
          ) : (
            <>
              <div style={{ padding: "10px" }}>
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height="40px"
                  style={{
                    borderRadius: "3px",
                    marginBottom: "10px",
                  }}
                />
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height="290px"
                  style={{
                    borderRadius: "3px",
                  }}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <ClearFilter
        open={isOpenFilter}
        noButtonClick={noButtonClick}
        yesButtonClick={yesButtonClick}
        onClose={closeClearFilter}
        filteredValue={filteredValue}
      />

      <Drawer
        anchor="right"
        open={!!selectedGeneralTaskId}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            width: { xs: "100%", sm: "380px", md: "500px" },
            backgroundColor: "#FFF",
          },
        }}
        sx={{ zIndex: 9 }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#FFF",
          }}
        >
          <Box
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "12px 16px",
              borderBottom: "1px solid #E9E9E9",
            }}
          >
            <Typography
              variant="h6"
              component="h2"
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#101828",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "calc(100% - 80px)",
                margin: "0 auto",
                textAlign: "center",
              }}
            >
              {taskById?.taskTitle || "Task Details"}
            </Typography>
            <IconButton
              onClick={handleCloseDrawer}
              size="small"
              sx={{
                position: "absolute",
                left: "16px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#000000",
                padding: "4px",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
                borderRadius: "5px",
                zIndex: 999,
                backgroundColor: "#fff",
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>

          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              padding: "0",
            }}
          >
            {selectedGeneralTaskId && (
              <TaskDetails
                initialTaskId={selectedGeneralTaskId}
                tasks={taskList}
                DeleteTask={DeleteTask}
                selectedLeadData={null}
                employees={employees}
                CreateComment={CreateComment}
                DeleteComment={DeleteComment}
                EditComment={EditComment}
                EditTask={EditTask}
                CreateTask={CreateTask}
                taskTypes={tasksTypes}
                setFromTaskEdit={() => { }}
                setTaskForEditing={() => { }}
                setShowAddTask={() => { }}
                showAddTask={false}
                isInDrawer={true}
                onCloseDrawer={handleCloseDrawer}
              />
            )}
          </Box>
        </Box>
      </Drawer>
    </div>
  );
}

export default CompletedTasks;
